module.exports = __webpack_public_path__ + "img/img37.dd6d8b28.png";